import React from 'react';
import { Send, Paperclip, Loader2, MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

/**
 * Bottom input bar + file upload, OR the closed-conversation banner.
 */
const ChatInput = ({
  conversation,
  newMessage,
  onMessageChange,
  onSend,
  isSending,
  fileInputRef,
  onFileUpload,
  onNewChat,
}) => {
  if (conversation?.status === 'closed') {
    return (
      <div className="p-4 border-t bg-gray-50 text-center" data-testid="chat-closed-banner">
        <div className="bg-gray-100 rounded-lg py-3 px-4 mb-3">
          <p className="text-sm font-medium text-gray-600">This conversation has ended</p>
          <p className="text-xs text-gray-400 mt-0.5">Thank you for chatting with us</p>
        </div>
        <Button
          onClick={onNewChat}
          size="sm"
          className="bg-green-600 hover:bg-green-700 w-full"
          data-testid="start-new-chat-btn"
        >
          <MessageCircle className="h-4 w-4 mr-2" /> Start New Chat
        </Button>
      </div>
    );
  }

  return (
    <form onSubmit={onSend} className="p-4 border-t bg-gray-50">
      <div className="flex gap-2">
        <input
          type="file"
          ref={fileInputRef}
          onChange={onFileUpload}
          className="hidden"
          accept="image/*,.pdf,.doc,.docx"
        />
        <button
          type="button"
          onClick={() => fileInputRef.current?.click()}
          className="p-2 text-gray-500 hover:text-green-600 transition-colors"
        >
          <Paperclip className="h-5 w-5" />
        </button>
        <Input
          value={newMessage}
          onChange={(e) => onMessageChange(e.target.value)}
          placeholder="Type a message..."
          className="flex-1"
          data-testid="chat-message-input"
        />
        <Button
          type="submit"
          size="sm"
          className="bg-green-600 hover:bg-green-700"
          disabled={isSending || !newMessage.trim()}
          data-testid="chat-send-btn"
        >
          {isSending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
        </Button>
      </div>
    </form>
  );
};

export default ChatInput;
